module.exports = __webpack_public_path__ + "media/images/icon_list/star-c52a6e8c983ec96b847febf5f08f5a30.svg";